module.exports = __webpack_public_path__ + "assets/img/txt-career-step.92068226.svg";